import { Controller } from '@hotwired/stimulus'
import { toastStack } from '~/modules/webawesome/toast'

// Turns a server-rendered carrier element into a Web Awesome toast. The element's
// inner HTML is the message; variant/icon/duration come from data values. The
// carrier removes itself once the toast has been dispatched to the stack.
export default class extends Controller {
  static values = {
    variant: { type: String, default: 'brand' },
    duration: { type: Number, default: 7000 },
    icon: String
  }

  connect() {
    toastStack().create(this.element.innerHTML.trim(), {
      variant: this.variantValue,
      duration: this.durationValue,
      icon: this.hasIconValue ? this.iconValue : undefined,
      allowHtml: true
    })

    this.element.remove()
  }
}
